import type { Supply48DataSource } from '@ebalance/proto/bffuser/v1/supply_48_data_model_pb'

/**
 * 契約 source の取引ID (public_trade_id)。市場 source (スポット・時間前) は
 * 取引先マスタを参照せず取引ID を持たないため undefined を返す (AC-S4D-039 ※)。
 * 契約 source でも取引ID が空文字なら undefined に正規化する。
 *
 * 「取引ID を持たない」を空文字ではなく undefined で表すのは、`''` を sentinel に
 * すると探索キーが `''` の時に取引ID の無い列へ誤一致しうるため (非空性の
 * invariant を呼び出し元の正規化に依存させない)。
 *
 * AC-S4D-052 のスクロール・ハイライト対象識別子の解決 (`resolveScrollTargetLegId`)
 * と、画面エクスポート CSV の取引ID 抽出 (`screenCsvExport.ts`) が共有する。
 */
export function sourcePublicTradeId(
  source: Supply48DataSource,
): string | undefined {
  if (source.detail.case !== 'contract') return undefined
  const id = source.detail.value.publicTradeId
  return id === '' ? undefined : id
}

/**
 * 遷移パラメータの契約識別子 (取引ID) から、現在のフィルタ結果 (legs) 内の
 * 対象列の legId (supply48SourceId) を解決する。
 *
 * AC-S4D-052 ※2: 指定された契約が現在のフィルタ・対象日で表示対象に存在しない
 * 場合 (受渡期間外の日を後から切り替えた等) は undefined を返す。呼び出し側は
 * この場合スクロール・ハイライトを行わない (存在しない列を探しに行って画面が
 * 不自然に動く事故を防ぐ)。
 *
 * 相対取引は 1:1 モデルに統一済み (leg テーブル廃止 #6547 / #6622) のため、
 * 取引ID は現在のフィルタ結果内で高々 1 列にしか一致しない (一意性の前提)。
 */
export function resolveScrollTargetLegId(
  legs: Supply48DataSource[],
  targetPublicTradeId: string,
): string | undefined {
  return legs.find((leg) => sourcePublicTradeId(leg) === targetPublicTradeId)
    ?.supply48SourceId
}
